module.exports = __webpack_public_path__ + "img/tinfoilchef-d65500be-5a85-4ed5-48a0-08d95b7e528f.png";